function bindDonateClickListeners() {
  $(".js-donate-next").click(function(ev) {
    var eyelevel = $(".donation-container").offset().top;
    var windowlevel = $(window).scrollTop();
    if (windowlevel > eyelevel) {
      $("html, body").animate({scrollTop: eyelevel}, 1000);
    }
    return true;
  });

  $(".js-donate").click(function(ev) {
    ev.preventDefault();

    var form = $(ev.target).closest("form");
    var clean_payu_scripts = function() {
      console.info("clean payu scripts");
      $("script").each(function() {
        if (this.src.startsWith("https://secure.payu.com/"))
        {
          console.log("clean payu script: "+this.src);
          this.parentElement.removeChild(this);
        }
      });
    };

    var wait_widget_load = function(callback) {
      var widget_loaded = false;
      $("script").each(function() {
        if (this.src.startsWith("https://secure.payu.com/front/widget/js/payu-widget.js"))
        {
          widget_loaded = true;
        }
      });
      if (widget_loaded && typeof PayU !== 'undefined') {
        callback();
      } else {
        setTimeout(function() { wait_widget_load(callback); }, 100);
      }
    };

    var what_if_we_are_blocked = function() {
      if (typeof PayU == 'undefined') {
        alert("Możliwe, że bloker reklam w przeglądarce blokuje załadowanie okienka PayU i uniemożliwia dokonania wpłaty. Prosimy o wyłączenie blokowania reklam na stronach Akcji Demokracji. Nie wyświetlamy reklam ani nie używamy mechanizmów śledzących innych firm lub organizacji.");
      };
    };

    window.widget = function(data, status) {
      console.log("Widget: "+status+"--> "+JSON.stringify(data));
      clean_payu_scripts();

      var script = document.createElement('script');
      script.src = "https://secure.payu.com/front/widget/js/payu-bootstrap.js";
      script.type = "text/javascript";
      script.id = "payu-bootstrap-script";
      window.rdonateId = data.id;
      $.each(data.widget, function(k,v) {
        script.setAttribute(k,v);
      });
      document.head.appendChild(script);

      wait_widget_load(function() {
        if (typeof data.cvv !== 'undefined') {
          PayU.Merchant.openWidgetCvv();
        } else {
          PayU.Merchant.openWidget();
        }
        // PayU widget is manipulating the overflow property but sometimes fails to set it back. Disable this.
        $('body').css('overflow', 'inherit');
        $('html').removeAttr('style');
      });
      setTimeout(what_if_we_are_blocked, 15000);
    };

    var post_form = function(data, status) {
      console.log("Form: "+status+"--> "+JSON.stringify(data));
      var oldform = document.querySelector('#payu-pay-form');
      if (oldform) {
        oldform.parentElement.removeChild(oldform);
      }

      var form = document.createElement('form');
      form.action = data.form.url;
      form.method = "post";
      form.id = "payu-pay-form";
      window.rdonateId = data.id;
      $.each(data.form.params, function(k,v) {
        if (v !== null) {
          var field = document.createElement('input');
          field.type = 'hidden';
          field.name = k;
          field.value = v;
          form.appendChild(field);
        }
      });
      document.querySelector('#donate-form-container-id').appendChild(form);
      form.submit();
    };

    // TODO: move to third step
    var form_or_widget = function(data, status) {
      if (typeof data.form !== 'undefined') {
        return post_form(data, status);
      } else if (typeof data.widget !== 'undefined') {
        return widget(data, status);
      } else {
        console.error("Rdonate js data doesn't contain form nor widget");
      }
    };

    if (form.checkValidity()) {
      $.post(form.attr('action'), form.serialize(), form_or_widget, 'json');
    } else {
      standard_validators();
      return false;
    }
  });
}

function bindPayuCallbacks() {
  window.payu_token_received = function(data) {
    $('body > div[style*="overflow: auto"]').remove();
    //   console.log("Tokenization: "+JSON.stringify(data));

    var redirect = function(data, statusCode) {
      //     console.log("Posted Order "+statusCode);
      if (data.redirect) {
        window.location = data.redirect;
      } else if (data.cvv) {
        window.widget(data, status);
      } else {
        //       console.log("Seems that we are fine! "+data.ok);
        $('body').css('overflow', 'inherit');
        nextAction();
      }
    };
    $.post("/payu/"+rdonateId+"/token", data, redirect,'json');
  };

  window.payu_cvv_received = function(data) {
    $('body > div[style*="overflow: auto"]').remove();
    console.log("Cvv: "+JSON.stringify(data));
  };
}


/*** EXPORTS FROM exports-loader ***/
exports["bindDonateClickListeners"] = (bindDonateClickListeners);
exports["bindPayuCallbacks"] = (bindPayuCallbacks);